import { CLIENT_PRODUCT } from './products.js';
import config from '../client-config.js';

export const LANDING = '/';
export const SIGN_IN = '/signin';
export const SIGN_OUT = '/signout';
export const HOME = '/home';
export const SHOWS = '/shows';
export const SHOW = '/shows/:showId';
export const PASSWORD_FORGET = `${SIGN_IN}/reset-password`;
export const USERS = '/users';
export const BILLING = '/billing';
export const BILLING_UPGRADE = `${BILLING}/upgrade`;
export const GLOBAL = '/global';
export const STATS_REDIRECT = '/stats/:orgId?';
export const QUEUES = '/queues';
export const PROFILE = '/profile';
export const PLAYER_TRANSLATIONS = '/translations';
export const PASSWORD_RESET = '/password-reset';
export const DASHBOARD_TRANSLATIONS = '/dashboard-translations';
export const SAML_PROVIDERS = '/saml-providers';
export const CLIENTS = '/clients';
export const AI_TAGGING_RUNS = '/ai-tagging-runs';
export const AI_TAGGING_RUN = `${AI_TAGGING_RUNS}/:orgId/:runId`;
export const AUTH_ACTION_HANDLER = '/auth-action-handler';
export const PRODUCT_SCRAPER_TEST_PAGE = '/public/product-scraper';
// Consent page of the MCP server's OAuth flow; reached via a redirect from the MCP service.
export const MCP_CONNECT = '/mcp-connect';
// Public token-authenticated product knowledge page. Mirrors the internal
// catalog product view routes: `/` is the General tab, `/knowledge` is the
// Intelligence tab, `/knowledge/:categoryId` shows atoms for a category, and
// `/knowledge/:categoryId/:atomId` focuses on a single atom.
export const PRODUCT_KNOWLEDGE = '/public/product-knowledge';
export const PRODUCT_KNOWLEDGE_TAB = `${PRODUCT_KNOWLEDGE}/knowledge`;
export const PRODUCT_KNOWLEDGE_CATEGORY = `${PRODUCT_KNOWLEDGE_TAB}/:categoryId`;
export const PRODUCT_KNOWLEDGE_ATOM = `${PRODUCT_KNOWLEDGE_TAB}/atoms/:atomId`;

export const REDIRECT_CALLBACK = '/redirect-callback';
export const EMBED_PLAYGROUND_ONE_TO_MANY = '/public/embed-playground';
export const DOWNLOAD_APP_WITH_PRODUCT = '/public/download-app/:product?';
export const UGC_RIGHTS_MGMT = '/public/ugc-rights-mgmt';
export const PAGE_404 = '/404';
export const NO_TEAM = '/no-team';
export const START_TRIAL = '/start-trial';
export const EMAIL_NOTIFICATIONS_UNSUBSCRIBED = '/public/email-notifications-unsubscribed';

export const REDIRECT_ORG_PREFIX = 'o';
export const REDIRECT_ORG_BASE_ROUTE = '/o/:orgId/';
export const ORG_BASE_ROUTE = '/:orgId/:selectedProduct?';

export const ONE_TO_MANY = '/:orgId/one-to-many';
export const ONE_TO_ONE = '/:orgId/one-to-one';
export const ON_DEMAND_SHORTCUT = '/on-demand';
export const ON_DEMAND = '/:orgId/on-demand';
export const LIVE = '/:orgId/live';
export const LIVE_SHORTCUT = '/live';
export const CALLS = '/:orgId/calls';
export const CALLS_SHORTCUT = '/calls';
export const ONE_TO_ANY = '/:orgId/:selectedProduct';
export const CHAT = '/:orgId/chat';
export const CLIENT_BASE = `/${CLIENT_PRODUCT}/:clientId`;

export const ORG_LOCALIZATION = `${ONE_TO_ANY}/localizations`;
export const ORG_LOCALIZATION_EDIT = `${ONE_TO_ANY}/localizations/:locale`;

export const ORG_USERS = `${ONE_TO_ANY}/users`;
export const ORG_USERS_EDIT = `${ONE_TO_ANY}/users/edit/:userId`;
export const ORG_USERS_INVITE = `${ONE_TO_ANY}/users/create`;
export const ORG_USER_PROFILE = `${ONE_TO_ANY}/user-profile`;
export const ORG_THEMES = `${ONE_TO_ANY}/themes`;
export const ORG_401 = `${ONE_TO_ANY}/401`;
export const ORG_API_KEYS = `${ONE_TO_ANY}/integrations/api-keys`;
export const ORG_WEBHOOKS = `${ONE_TO_ANY}/integrations/webhooks`;
export const ORG_INTEGRATIONS = `${ONE_TO_ANY}/integrations`;
export const ORG_THEME = '/:orgId/:selectedProduct?/themes/:themeId/:product?/:section?';
export const ORG_EMBED_STATS = `${ONE_TO_ANY}/embed-stats`;
export const ORG_GENERAL_SETTINGS = `${ONE_TO_ANY}/general-settings`;
export const ORG_PRODUCT_FEED = `${ONE_TO_ANY}/product-feed`;
export const ORG_PRODUCT_FEED_NEW = `${ONE_TO_ANY}/product-feed/new`;
export const ORG_PRODUCT_FEED_ID = `${ONE_TO_ANY}/product-feed/:id`;
export const ORG_PRODUCTS = `${ONE_TO_ANY}/products`;
export const ORG_PRODUCTS_ID = `${ONE_TO_ANY}/products/:id`;
export const ORG_PRODUCTS_NEW = `${ONE_TO_ANY}/products/new`;
export const ORG_PRODUCTS_INTELLIGENCE = `${ONE_TO_ANY}/products/intelligence`;
export const ORG_PRODUCTS_AI_VISIBILITY = `${ONE_TO_ANY}/products/ai-visibility`;
// Full-page catalog product view — replaces the SlotPublisher side panel when
// the productKnowledgeLayer feature flag is on. Matches both Live and VOD
// contexts via the :selectedProduct segment. The base `/view` is the General
// tab; `/view/knowledge` is the Intelligence tab, with nested drill-ins for
// a single category and a single atom.
export const ORG_CATALOG_PRODUCT_VIEW = `${ONE_TO_ANY}/products/:productId/view`;
export const ORG_CATALOG_PRODUCT_KNOWLEDGE = `${ORG_CATALOG_PRODUCT_VIEW}/knowledge`;
export const ORG_CATALOG_PRODUCT_AIV = `${ORG_CATALOG_PRODUCT_VIEW}/ai-visibility`;
export const ORG_CATALOG_PRODUCT_KNOWLEDGE_CATEGORY = `${ORG_CATALOG_PRODUCT_KNOWLEDGE}/:categoryId`;
export const ORG_CATALOG_PRODUCT_KNOWLEDGE_ATOM = `${ORG_CATALOG_PRODUCT_KNOWLEDGE}/atoms/:atomId`;

export const ORG_ONE_TO_MANY_HOME = `${LIVE}`;
export const ORG_SHOWS = `${LIVE}/shows`;
export const ORG_SHOW = `${LIVE}/shows/:showId/:selectedTab?`;
export const ORG_SHOW_MODERATE = `${LIVE}/shows/:showId/moderate`;
export const ORG_SHOW_EDIT = `${LIVE}/shows/:showId/edit`;
export const ORG_MODULES = `${LIVE}/widgets`;
export const ORG_MODULES_PREFIX = ORG_MODULES;
export const ORG_LANDING_PAGE = `${ORG_MODULES_PREFIX}/channels/:channelId`;
export const ORG_FLOATING_WIDGET = `${LIVE}/floating-widget`;
export const ORG_FLOATING_WIDGET_SETTINGS = `${LIVE}/floating-widget/:widgetId`;
export const ORG_STATS = `${LIVE}/stats/:pageName?/:showId?`;
export const ORG_DATA_REPORTS = `${LIVE}/stats/data-reports`;
export const ORG_DATA_EXPORT_JOBS = `${LIVE}/stats/data-exports/:jobId?`;
export const ORG_FACEBOOK_INTEGRATION = `${LIVE}/integrations/facebook`;
export const ORG_INSTAGRAM_INTEGRATION = `${LIVE}/integrations/instagram`;
export const ORG_TIKTOK_INTEGRATION = `${LIVE}/integrations/tiktok`;
export const ORG_TIKTOK_RTMP_INTEGRATION = `${LIVE}/integrations/tiktok-rtmp`;
export const ORG_YOUTUBE_INTEGRATION = `${LIVE}/integrations/youtube`;
export const ORG_CUSTOM_RTMP_INTEGRATION = `${LIVE}/integrations/customrtmp`;
export const ORG_ONE_TO_MANY_UPSELL = `${LIVE}/learn-more`;
export const ORG_PRODUCT_SCRAPER = `${ONE_TO_ANY}/integrations/product-scraper`;
export const ORG_SHOPIFY_INTEGRATION = `${ONE_TO_ANY}/integrations/shopify`;
export const ORG_ONE_TO_MANY_THEMING = `${LIVE}/theming/:themeId/:product`;
export const ORG_ONE_TO_MANY_THEMES = `${LIVE}/theming`;
export const ORG_ONE_TO_MANY_AI = `${LIVE}/ai`;
export const ORG_ONE_TO_MANY_AIV = `${LIVE}/aiv`;
export const ORG_ONE_TO_MANY_AIV_ONBOARDING = `${LIVE}/aiv/onboarding`;
export const ORG_ONE_TO_MANY_AIV_TOPICS = `${LIVE}/aiv/topics`;
export const ORG_ONE_TO_MANY_AIV_TOPIC = `${LIVE}/aiv/topics/:topicId/:aivTab?`;
export const ORG_ONE_TO_MANY_AIV_PRODUCTS = `${LIVE}/aiv/products`;
export const ORG_ONE_TO_MANY_AIV_PRODUCT = `${LIVE}/aiv/products/:productId`;
export const ORG_ONE_TO_MANY_AIV_BRAND = `${LIVE}/aiv/brand`;
export const ORG_ONE_TO_MANY_VOD = `${LIVE}/vod`;

export const ORG_ONE_TO_ONE_HOME = `${CALLS}`;
export const ORG_CALL_CONFIGURATIONS = `${CALLS}/call-configurations`;
export const ORG_CALL_LIST = `${CALLS}/callList`;
export const ORG_CALL_INSIGHTS = `${CALLS}/call-insights`;
export const ORG_CALL_STATS = `${CALLS}/callStats/:pageName?`;
export const ORG_QUEUES = `${CALLS}/queues`;
export const ORG_AGENT_TOOL = `${CALLS}/agent-tool`;
export const ORG_ONE_TO_ONE_UPSELL = `${CALLS}/learn-more`;
export const ORG_CALL_BACKGROUND = `${CALLS}/call-background`;
export const ORG_CALL_BOOKINGS = `${CALLS}/call-bookings`;
export const ORG_CALL_BOOKING_NOTIFICATIONS = `${CALLS}/call-booking-notifications`;
export const ORG_CALL_BOOKING_RESOURCES = `${CALLS}/call-booking-resources`;
export const ORG_CALL_BOOKING_SERVICE = `${CALLS}/call-booking-service/:serviceId`;
export const ORG_CALL_BOOKING_SERVICES = `${CALLS}/call-booking-services`;
export const ORG_CALL_AGENT_AVAILABILITY = `${CALLS}/my-availability`;
export const ORG_ONE_TO_ONE_THEMES = `${CALLS}/theming`;
export const ORG_ONE_TO_ONE_THEMING = `${CALLS}/theming/:themeId/:product`;
export const ORG_GROUPS = `${CALLS}/groups`;
export const ORG_GROUP = `${CALLS}/groups/:groupId`;

export const ORG_ON_DEMAND_HOME = `${ON_DEMAND}`;
export const ORG_ON_DEMAND_VIDEOS = `${ON_DEMAND}/videos`;
export const ORG_ON_DEMAND_VIDEOS_EDIT_NEW = `${ON_DEMAND}/videos/edit-new`;
export const ORG_ON_DEMAND_VIDEOS_IMPORT = `${ON_DEMAND}/videos/import/:source`;
export const ORG_ON_DEMAND_VIDEOS_IMPORT_EDIT = `${ON_DEMAND}/videos/import/:source/edit/:showId`;
export const ORG_ON_DEMAND_VIDEOS_BULK_IMPORT_PREVIEW = `${ON_DEMAND}/videos/import/bulk-csv/preview`;
export const ORG_ON_DEMAND_VIDEOS_BULK_IMPORT_STATUS = `${ON_DEMAND}/videos/bulk-imports/:jobId`;
export const ORG_ON_DEMAND_VIDEO_SETUP = `${ON_DEMAND}/videos/:videoId/setup`;
export const ORG_ON_DEMAND_PRODUCTS = `${ON_DEMAND}/products`;
export const ORG_ON_DEMAND_PRODUCT_SETUP = `${ON_DEMAND}/products/:productId/setup`;
export const ORG_ON_DEMAND_PRODUCT_NEW = `${ON_DEMAND}/products/new`;
export const ORG_ON_DEMAND_UGC = `${ON_DEMAND}/ugc`;
export const ORG_ON_DEMAND_UGC_SAVED = `${ON_DEMAND}/ugc/saved`;
export const ORG_ON_DEMAND_UGC_RIGHTS_MANAGEMENT = `${ON_DEMAND}/ugc/rights-management`;
export const ORG_ON_DEMAND_DISTRIBUTION_PAGES = `${ON_DEMAND}/pages`;
export const ORG_ON_DEMAND_DISTRIBUTION_CONTAINERS = `${ON_DEMAND}/pages/:pageId/playlists`;
export const ORG_ON_DEMAND_DISTRIBUTION_CONTAINER = `${ON_DEMAND}/pages/:pageId/playlists/:containerId`;
export const ORG_ON_DEMAND_STATS = `${ON_DEMAND}/stats`;
export const ORG_ON_DEMAND_DATA_EXPORT_JOBS = `${ON_DEMAND}/stats/data-exports/:jobId?`;
export const ORG_ON_DEMAND_SETTINGS = `${ON_DEMAND}/settings`;
export const ORG_ON_DEMAND_GET_STARTED = `${ON_DEMAND}/get-started`;
export const ORG_ON_DEMAND_THEMES = `${ON_DEMAND}/theming`;
export const ORG_ON_DEMAND_PLAYLISTS = `${ON_DEMAND}/playlists`;
export const ORG_ON_DEMAND_PLAYLISTS_NEW = `${ON_DEMAND}/playlists/new`;
export const ORG_ON_DEMAND_PLAYLISTS_EDIT = `${ON_DEMAND}/playlists/:playlistId`;
export const ORG_ON_DEMAND_PLACEMENTS = `${ON_DEMAND}/placements`;
export const ORG_ON_DEMAND_PLACEMENTS_EDIT = `${ON_DEMAND}/placements/:placementId`;
export const ORG_ON_DEMAND_PLACEMENTS_NEW = `${ON_DEMAND}/placements/new`;
export const ORG_ON_DEMAND_PLACEMENTS_PAGES = `${ON_DEMAND}/placements/pages`;
export const ORG_ON_DEMAND_PLACEMENTS_PAGE_CONTAINERS = `${ON_DEMAND}/placements/pages/:pageId/containers`;
export const ORG_ON_DEMAND_PLACEMENTS_PAGE_CONTAINER_PLACEMENTS = `${ON_DEMAND}/placements/pages/:pageId/containers/:containerId/placements`;
export const ORG_ON_DEMAND_APPEARANCES = `${ON_DEMAND}/appearances`;
export const ORG_ON_DEMAND_APPEARANCES_EDIT = `${ON_DEMAND}/appearances/:appearanceId`;

export const ORG_ON_DEMAND_ACTIONS = `${ON_DEMAND}/actions`;
export const ORG_ON_DEMAND_ACTIONS_SETUP = `${ON_DEMAND}/actions/:actionId/setup`;
export const ORG_ON_DEMAND_LINKS = `${ON_DEMAND}/links`;
export const ORG_ON_DEMAND_LINKS_NEW = `${ON_DEMAND}/links/new`;
export const ORG_ON_DEMAND_LINKS_EDIT = `${ON_DEMAND}/links/:linkId`;

export const ORG_ON_DEMAND_THEMING = `${ON_DEMAND}/theming/:themeId/:product`;

export const CLIENT_401 = `${CLIENT_BASE}/401`;
export const CLIENT_USAGE = `${CLIENT_BASE}/usage`;
export const CLIENT_BILLING = `${CLIENT_BASE}${BILLING}`;
export const CLIENT_BILLING_UPGRADE = `${CLIENT_BILLING}/upgrade`;
export const CLIENT_USERS = `${CLIENT_BASE}/users`;
export const CLIENT_USERS_INVITE = `${CLIENT_USERS}/create`;
export const CLIENT_USERS_EDIT = `${CLIENT_USERS}/:userId/edit`;

export const SUPERADMIN_ROUTES = [GLOBAL, DASHBOARD_TRANSLATIONS, SAML_PROVIDERS, CLIENTS, AI_TAGGING_RUNS, AI_TAGGING_RUN];
export const SHORTCUTS_ROUTES = [SHOWS, SHOW, ON_DEMAND_SHORTCUT, LIVE_SHORTCUT, CALLS_SHORTCUT, USERS, STATS_REDIRECT, PROFILE, BILLING_UPGRADE, BILLING, PAGE_404];

export const PRODUCT_ROUTES = {
  ORG_ONE_TO_MANY_HOME: `${ONE_TO_ANY}`,
  ORG_INTEGRATIONS: `${ONE_TO_ANY}/integrations`,
  ORG_SHOWS: `${ONE_TO_ANY}/shows`,
  ORG_SHOW: `${ONE_TO_ANY}/shows/:showId/:selectedTab?`,
  ORG_SHOW_MODERATE: `${ONE_TO_ANY}/shows/:showId/moderate`,
  ORG_SHOW_EDIT: `${ONE_TO_ANY}/shows/:showId/edit`,
  ORG_MODULES: `${ONE_TO_ANY}/widgets`,
  ORG_LANDING_PAGE: `${ONE_TO_ANY}/widgets/channels/:channelId`,
  ORG_FLOATING_WIDGET: `${ONE_TO_ANY}/floating-widget`,
  ORG_FLOATING_WIDGET_SETTINGS: `${ONE_TO_ANY}/floating-widget/:widgetId`,
  ORG_DATA_REPORTS: `${ONE_TO_ANY}/stats/data-reports`,
  ORG_DATA_EXPORT_JOBS: `${ONE_TO_ANY}/stats/data-exports/:jobId?`,
  ORG_STATS: `${ONE_TO_ANY}/stats/:pageName?/:showId?`,
  ORG_FACEBOOK_INTEGRATION: `${ONE_TO_ANY}/integrations/facebook`,
  ORG_INSTAGRAM_INTEGRATION: `${ONE_TO_ANY}/integrations/instagram`,
  ORG_TIKTOK_INTEGRATION: `${ONE_TO_ANY}/integrations/tiktok`,
  ORG_TIKTOK_RTMP_INTEGRATION: `${ONE_TO_ANY}/integrations/tiktok-rtmp`,
  ORG_YOUTUBE_INTEGRATION: `${ONE_TO_ANY}/integrations/youtube`,
  ORG_CUSTOM_RTMP_INTEGRATION: `${ONE_TO_ANY}/integrations/customrtmp`,
  ORG_ONE_TO_MANY_UPSELL: `${ONE_TO_ANY}/learn-more`,
  ORG_PRODUCT_SCRAPER: `${ONE_TO_ANY}/integrations/product-scraper`,
  ORG_SHOPIFY_INTEGRATION: `${ONE_TO_ANY}/integrations/shopify`,
  ORG_ONE_TO_MANY_THEMES: `${ONE_TO_ANY}/theming`,
  ORG_ONE_TO_MANY_THEMING: `${ONE_TO_ANY}/theming/:themeId/:product`,
  ORG_ONE_TO_MANY_AI: `${ONE_TO_ANY}/ai`,
  ORG_ONE_TO_MANY_AIV: `${ONE_TO_ANY}/aiv`,
  ORG_ONE_TO_MANY_AIV_ONBOARDING: `${ONE_TO_ANY}/aiv/onboarding`,
  ORG_ONE_TO_MANY_AIV_TOPICS: `${ONE_TO_ANY}/aiv/topics`,
  ORG_ONE_TO_MANY_AIV_TOPIC: `${ONE_TO_ANY}/aiv/topics/:topicId/:aivTab?`,
  ORG_ONE_TO_MANY_AIV_PRODUCTS: `${ONE_TO_ANY}/aiv/products`,
  ORG_ONE_TO_MANY_AIV_PRODUCT: `${ONE_TO_ANY}/aiv/products/:productId`,
  ORG_ONE_TO_MANY_AIV_BRAND: `${ONE_TO_ANY}/aiv/brand`,
  ORG_CATALOG_PRODUCT_AIV: `${ONE_TO_ANY}/products/:productId/view/ai-visibility`,
  ORG_ONE_TO_MANY_VOD: `${ONE_TO_ANY}/vod`,

  ORG_ONE_TO_ONE_HOME: `${ONE_TO_ANY}`,
  ORG_CALL_LIST: `${ONE_TO_ANY}/callList`,
  ORG_CALL_INSIGHTS: `${ONE_TO_ANY}/call-insights`,
  ORG_CALL_STATS: `${ONE_TO_ANY}/callStats/:pageName?`,
  ORG_QUEUES: `${ONE_TO_ANY}/queues`,
  ORG_AGENT_TOOL: `${ONE_TO_ANY}/agent-tool`,
  ORG_ONE_TO_ONE_UPSELL: `${ONE_TO_ANY}/learn-more`,
  ORG_GROUPS: `${ONE_TO_ANY}/groups`,
  ORG_GROUP: `${ONE_TO_ANY}/groups/:groupId`,
  ORG_CALL_BACKGROUND: `${ONE_TO_ANY}/call-background`,
  ORG_CALL_BOOKINGS: `${ONE_TO_ANY}/call-bookings`,
  ORG_CALL_BOOKING_NOTIFICATIONS: `${ONE_TO_ANY}/call-booking-notifications`,
  ORG_CALL_BOOKING_SERVICE: `${ONE_TO_ANY}/call-booking-service/:serviceId`,
  ORG_CALL_BOOKING_SERVICES: `${ONE_TO_ANY}/call-booking-services`,
  ORG_CALL_BOOKING_RESOURCES: `${ONE_TO_ANY}/call-booking-resources`,
  ORG_CALL_AGENT_AVAILABILITY: `${ONE_TO_ANY}/my-availability`,
  ORG_ONE_TO_ONE_THEMES: `${ONE_TO_ANY}/theming`,
  ORG_ONE_TO_ONE_THEMING: `${ONE_TO_ANY}/theming/:themeId/:product`,

  ORG_ON_DEMAND_HOME: `${ONE_TO_ANY}`,
  ORG_ON_DEMAND_VIDEOS: `${ONE_TO_ANY}/videos`,
  ORG_ON_DEMAND_VIDEOS_EDIT_NEW: `${ONE_TO_ANY}/videos/edit-new`,
  ORG_ON_DEMAND_VIDEOS_IMPORT: `${ONE_TO_ANY}/videos/import/:source`,
  ORG_ON_DEMAND_VIDEOS_IMPORT_EDIT: `${ONE_TO_ANY}/videos/import/:source/edit/:showId`,
  ORG_ON_DEMAND_VIDEOS_BULK_IMPORT_PREVIEW: `${ONE_TO_ANY}/videos/import/bulk-csv/preview`,
  ORG_ON_DEMAND_VIDEOS_BULK_IMPORT_STATUS: `${ONE_TO_ANY}/videos/bulk-imports/:jobId`,
  ORG_ON_DEMAND_VIDEO_SETUP: `${ONE_TO_ANY}/videos/:videoId/setup`,
  ORG_ON_DEMAND_PRODUCTS: `${ONE_TO_ANY}/products`,
  ORG_ON_DEMAND_PRODUCT_SETUP: `${ONE_TO_ANY}/products/:productId/setup`,
  ORG_ON_DEMAND_PRODUCT_NEW: `${ONE_TO_ANY}/products/new`,
  ORG_ON_DEMAND_UGC: `${ONE_TO_ANY}/ugc`,
  ORG_ON_DEMAND_UGC_SAVED: `${ONE_TO_ANY}/ugc/saved/:curationId?`,
  ORG_ON_DEMAND_UGC_RIGHTS_MANAGEMENT: `${ONE_TO_ANY}/ugc/rights-management`,
  ORG_ON_DEMAND_DISTRIBUTION_PAGES: `${ONE_TO_ANY}/pages`,
  ORG_ON_DEMAND_DISTRIBUTION_CONTAINERS: `${ONE_TO_ANY}/pages/:pageId/playlists`,
  ORG_ON_DEMAND_DISTRIBUTION_CONTAINER: `${ONE_TO_ANY}/pages/:pageId/playlists/:containerId`,
  ORG_ON_DEMAND_STATS: `${ONE_TO_ANY}/stats`,
  ORG_ON_DEMAND_SETTINGS: `${ONE_TO_ANY}/settings`,
  ORG_ON_DEMAND_GET_STARTED: `${ONE_TO_ANY}/get-started`,
  ORG_ON_DEMAND_THEMES: `${ONE_TO_ANY}/theming`,
  ORG_ON_DEMAND_PLAYLISTS: `${ONE_TO_ANY}/playlists`,
  ORG_ON_DEMAND_PLAYLISTS_NEW: `${ONE_TO_ANY}/playlists/new`,
  ORG_ON_DEMAND_PLAYLISTS_EDIT: `${ONE_TO_ANY}/playlists/:playlistId`,
  ORG_ON_DEMAND_PLACEMENTS: `${ONE_TO_ANY}/placements`,
  ORG_ON_DEMAND_PLACEMENTS_NEW: `${ONE_TO_ANY}/placements/new`,
  ORG_ON_DEMAND_PLACEMENTS_EDIT: `${ONE_TO_ANY}/placements/:placementId`,
  ORG_ON_DEMAND_PLACEMENTS_PAGES: `${ONE_TO_ANY}/placements/pages`,
  ORG_ON_DEMAND_PLACEMENTS_PAGE_CONTAINERS: `${ONE_TO_ANY}/placements/pages/:pageId/containers`,
  ORG_ON_DEMAND_PLACEMENTS_PAGE_CONTAINER_PLACEMENTS: `${ONE_TO_ANY}/placements/pages/:pageId/containers/:containerId/placements`,
  ORG_ON_DEMAND_APPEARANCES: `${ONE_TO_ANY}/appearances`,
  ORG_ON_DEMAND_APPEARANCES_EDIT: `${ONE_TO_ANY}/appearances/:appearanceId`,

  ORG_ON_DEMAND_ACTIONS: `${ONE_TO_ANY}/actions`,
  ORG_ON_DEMAND_ACTIONS_SETUP: `${ONE_TO_ANY}/actions/:actionId/setup`,
  ORG_ON_DEMAND_LINKS: `${ONE_TO_ANY}/links`,
  ORG_ON_DEMAND_LINKS_NEW: `${ONE_TO_ANY}/links/new`,
  ORG_ON_DEMAND_LINKS_EDIT: `${ONE_TO_ANY}/links/:linkId`,
  ORG_ON_DEMAND_THEMING: `${ONE_TO_ANY}/theming/:themeId/:product`,

  ORG_CHAT_HOME: `${ONE_TO_ANY}`,
  ORG_CHAT_STATS: `${ONE_TO_ANY}/stats`,
  ORG_CHAT_CONTACTS: `${ONE_TO_ANY}/contacts`,
  ORG_CHAT_CONTACT: `${ONE_TO_ANY}/contacts/:contactId`,
  ORG_CHAT_DEPARTMENTS: `${ONE_TO_ANY}/departments`,
  ORG_CHAT_MANAGE_STORES: `${ONE_TO_ANY}/manage-stores`,
  ORG_CHAT_CMS_POSTS: `${ONE_TO_ANY}/posts`,
  ORG_CHAT_ACCUONTS_OVERVIEW: `${ONE_TO_ANY}/config`,
  ORG_CHAT_CONFIG_STORE_APP: `${ONE_TO_ANY}/config/mobile`,
  ORG_CHAT_CONFIG_PLUGIN: `${ONE_TO_ANY}/config/plugin`,
  ORG_CHAT_CONFIG_RETAILER: `${ONE_TO_ANY}/config/retailer`,
  ORG_CHAT_CONFIG_PRODUCT_FEED: `${ONE_TO_ANY}/config/product-feed`,
  ORG_CHAT_WEB_APP: `${ONE_TO_ANY}/app`,
  ORG_CHAT_WEB_APP_CHAT: `${ONE_TO_ANY}/app/chat`,
  ORG_CHAT_WEB_APP_PROFILE: `${ONE_TO_ANY}/app/profile`,

};

export const UNAUTHENTICATED_ROUTES = [
  SIGN_IN,
  PASSWORD_FORGET,
  PASSWORD_RESET,
  AUTH_ACTION_HANDLER,
  PRODUCT_SCRAPER_TEST_PAGE,
  MCP_CONNECT,
  PRODUCT_KNOWLEDGE,
  REDIRECT_CALLBACK,
  EMBED_PLAYGROUND_ONE_TO_MANY,
  DOWNLOAD_APP_WITH_PRODUCT,
  START_TRIAL,
  UGC_RIGHTS_MGMT,
  EMAIL_NOTIFICATIONS_UNSUBSCRIBED,
];

export const LIVE_ONLY_ROUTES = [
  ORG_ONE_TO_MANY_HOME,
  ORG_SHOWS,
  ORG_SHOW,
  ORG_SHOW_MODERATE,
  ORG_SHOW_EDIT,
  ORG_MODULES,
  ORG_LANDING_PAGE,
  ORG_FLOATING_WIDGET,
  ORG_STATS,
  ORG_FACEBOOK_INTEGRATION,
  ORG_INSTAGRAM_INTEGRATION,
  ORG_TIKTOK_INTEGRATION,
  ORG_TIKTOK_RTMP_INTEGRATION,
  ORG_YOUTUBE_INTEGRATION,
  ORG_CUSTOM_RTMP_INTEGRATION,
  ORG_THEMES,
  ORG_THEME,
  ORG_PRODUCT_SCRAPER,
  PLAYER_TRANSLATIONS,
  ORG_ONE_TO_MANY_VOD,
];

export const ONE_TO_ONE_ONLY_ROUTES = [
  ORG_AGENT_TOOL,
  ORG_CALL_BACKGROUND,
  ORG_CALL_LIST,
  ORG_CALL_INSIGHTS,
  ORG_CALL_STATS,
  ORG_ONE_TO_ONE_HOME,
  ORG_QUEUES,
  ORG_CALL_AGENT_AVAILABILITY,
  ORG_CALL_BOOKINGS,
  ORG_CALL_BOOKING_SERVICE,
  ORG_CALL_BOOKING_RESOURCES,
  ORG_CALL_CONFIGURATIONS,
  ORG_GROUPS,
  ORG_GROUP,
  ORG_ONE_TO_ONE_THEMES,
  ORG_ONE_TO_ONE_THEMING,
];

export const ON_DEMAND_ONLY_ROUTES = [
  ORG_ON_DEMAND_HOME,
  ORG_ON_DEMAND_VIDEOS,
  ORG_ON_DEMAND_VIDEO_SETUP,
  ORG_ON_DEMAND_PRODUCTS,
  ORG_ON_DEMAND_PRODUCT_SETUP,
  ORG_ON_DEMAND_UGC,
  ORG_ON_DEMAND_UGC_SAVED,
  ORG_ON_DEMAND_UGC_RIGHTS_MANAGEMENT,
  ORG_ON_DEMAND_DISTRIBUTION_PAGES,
  ORG_ON_DEMAND_STATS,
  ORG_ON_DEMAND_DATA_EXPORT_JOBS,
  ORG_ON_DEMAND_SETTINGS,
  ORG_ON_DEMAND_GET_STARTED,
  ORG_ON_DEMAND_ACTIONS,
  ORG_ON_DEMAND_ACTIONS_SETUP,
  ORG_ON_DEMAND_THEMES,
  ORG_ON_DEMAND_THEMING,
  ORG_ON_DEMAND_PLAYLISTS,
  ORG_ON_DEMAND_PLACEMENTS,
  ORG_ON_DEMAND_APPEARANCES,
  ORG_ON_DEMAND_PLACEMENTS_EDIT,
  ORG_ON_DEMAND_PLACEMENTS_PAGES,
  ORG_ON_DEMAND_PLACEMENTS_PAGE_CONTAINERS,
  ORG_ON_DEMAND_PLACEMENTS_PAGE_CONTAINER_PLACEMENTS,
];

export const CLIENT_ONLY_ROUTES = [
  CLIENT_USAGE,
  CLIENT_BILLING,
];

export const CHAT_ONLY_ROUTES = [
  CHAT,
  PRODUCT_ROUTES.ORG_CHAT_HOME,
  PRODUCT_ROUTES.ORG_CHAT_STATS,
  PRODUCT_ROUTES.ORG_CHAT_MANAGE_STORES,
  PRODUCT_ROUTES.ORG_CHAT_CMS_POSTS,
  PRODUCT_ROUTES.ORG_CHAT_ACCUONTS_OVERVIEW,
  PRODUCT_ROUTES.ORG_CHAT_CONFIG_STORE_APP,
  PRODUCT_ROUTES.ORG_CHAT_CONFIG_PLUGIN,
  PRODUCT_ROUTES.ORG_CHAT_CONFIG_RETAILER,
  PRODUCT_ROUTES.ORG_CHAT_CONFIG_PRODUCT_FEED,
];

export const UPSELL_ROUTES = [ORG_ONE_TO_ONE_UPSELL, ORG_ONE_TO_MANY_UPSELL];

export const DELEGATED_CHAT_ROUTES = [
  {
    route: PRODUCT_ROUTES.ORG_CHAT_MANAGE_STORES,
    iframeBaseUrl: config.chatDashboardBaseUrl,
    iframeRoute: '/manage-stores',
  },
  {
    route: PRODUCT_ROUTES.ORG_CHAT_CMS_POSTS,
    iframeBaseUrl: config.chatDashboardBaseUrl,
    iframeRoute: '/cms',
  },
  {
    route: PRODUCT_ROUTES.ORG_CHAT_CONFIG_STORE_APP,
    iframeBaseUrl: config.chatDashboardBaseUrl,
    iframeRoute: '/config/mobile',
  },
  {
    route: PRODUCT_ROUTES.ORG_CHAT_CONFIG_PLUGIN,
    iframeBaseUrl: config.chatDashboardBaseUrl,
    iframeRoute: '/config/plugin',
  },
  {
    route: PRODUCT_ROUTES.ORG_CHAT_CONFIG_RETAILER,
    iframeBaseUrl: config.chatDashboardBaseUrl,
    iframeRoute: '/config/retailer',
  },
  {
    route: PRODUCT_ROUTES.ORG_CHAT_CONFIG_PRODUCT_FEED,
    iframeBaseUrl: config.chatDashboardBaseUrl,
    iframeRoute: '/config/product-feed',
  },
  {
    route: PRODUCT_ROUTES.ORG_CHAT_WEB_APP,
    iframeBaseUrl: config.chatWebAppBaseUrl,
    iframeRoute: '/',
  },
  {
    route: PRODUCT_ROUTES.ORG_CHAT_WEB_APP_CHAT,
    iframeBaseUrl: config.chatWebAppBaseUrl,
    iframeRoute: '/chats',
  },
  {
    route: PRODUCT_ROUTES.ORG_CHAT_WEB_APP_PROFILE,
    iframeBaseUrl: config.chatWebAppBaseUrl,
    iframeRoute: '/settings',
  },
  {
    route: PRODUCT_ROUTES.ORG_CHAT_CONTACT,
    iframeBaseUrl: config.chatWebAppBaseUrl,
    iframeRoute: '/conversation',
    subPageOf: PRODUCT_ROUTES.ORG_CHAT_CONTACTS,
  },
];

export const DELEGATED_ROUTES = [
  ...DELEGATED_CHAT_ROUTES,
];

export const buildRoute = (route, params = {}, queryParams) => {
  const startsWithSlash = route.startsWith('/');

  const parts = route
    .split('/')
    .filter((seg, idx) => !(idx === 0 && seg === ''))
    .map((seg) => {
      if (!seg.startsWith(':')) return seg; // literal segment

      const name = seg.replace(/[^a-z0-9]*/gi, '');
      const optional = seg.endsWith('?');
      const value = params[name];
      const missing = value === undefined || value === null || value === '';

      if (missing && !optional) {
        throw new Error(`Required route param ${name} was not provided to route builder`);
      }

      return missing ? null : encodeURIComponent(String(value));
    })
    .filter(Boolean);

  const basePath = (startsWithSlash ? '/' : '') + parts.join('/');
  const trimmedBasePath = basePath.replace(/\/+$/, '');

  if (!queryParams) return trimmedBasePath;

  const entries = Object.entries(queryParams).flatMap(([key, val]) => {
    const values = Array.isArray(val) ? val : [val];
    return values
      .filter((v) => v !== undefined && v !== null && v !== '')
      .map((v) => [key, String(v)]);
  });

  const qs = new URLSearchParams(entries).toString();
  return qs ? `${trimmedBasePath}?${qs}` : trimmedBasePath;
};

// Query param used to remember where a connect/redirect flow was started, so the
// destination page can send the user back (e.g. the social integration pages).
export const RETURN_TO_PARAM = 'returnTo';

// Reads the return path from a location `search` string. Only accepts a
// same-origin absolute path ("/...", not "//...") to avoid open redirects;
// returns null otherwise.
export const getReturnToPath = (search) => {
  const value = new URLSearchParams(search).get(RETURN_TO_PARAM);
  if (value && value.startsWith('/') && !value.startsWith('//')) return value;
  return null;
};
